import {
  GET_LEGALRUMIJA,
  GET_LEGALRUMIJA_SUCCESS,
  GET_LEGALRUMIJA_FAIL,
  DELETE_LEGALRUMIJA,
  DELETE_LEGALRUMIJA_SUCCESS,
  DELETE_LEGALRUMIJA_FAIL,
  UPDATE_LEGALRUMIJA,
  UPDATE_LEGALRUMIJA_SUCCESS,
  UPDATE_LEGALRUMIJA_FAIL,
  ADD_NEW_LEGALRUMIJA,
  ADD_LEGALRUMIJA_SUCCESS,
  ADD_LEGALRUMIJA_FAIL,
  LEGALRUMIJA_LOADING,
  LEGALRUMIJA_RESET
} from "./actionType";

export const resetLegalRumijaState = (actionType) => ({
  type: LEGALRUMIJA_RESET,
  payload: { actionType },
});

export const getLegalRumijaSuccess = (actionType, data) => ({
  type: GET_LEGALRUMIJA_SUCCESS,
  payload: { actionType, data },
});

export const getLegalRumijaFail = (actionType, error) => ({
  type: GET_LEGALRUMIJA_FAIL,
  payload: { actionType, error },
});

export const getLegalRumija = data => ({
  type: GET_LEGALRUMIJA,
  payload: data,
});

export const getLegalRumijaLoading = () => ({
  type: LEGALRUMIJA_LOADING
});

export const deleteLegalRumija = data => ({
  type: DELETE_LEGALRUMIJA,
  payload: data,
});

export const deleteLegalRumijaSuccess = data => ({
  type: DELETE_LEGALRUMIJA_SUCCESS,
  payload: data,
});

export const deleteLegalRumijaFail = error => ({
  type: DELETE_LEGALRUMIJA_FAIL,
  payload: error,
});

export const updateLegalRumija = data => ({
  type: UPDATE_LEGALRUMIJA,
  payload: data,
});

export const updateLegalRumijaFail = error => ({
  type: UPDATE_LEGALRUMIJA_FAIL,
  payload: error,
});

export const updateLegalRumijaSuccess = data => ({
  type: UPDATE_LEGALRUMIJA_SUCCESS,
  payload: data,
});

export const addNewLegalRumija = data => ({
  type: ADD_NEW_LEGALRUMIJA,
  payload: data,
});

export const addLegalRumijaSuccess = data => ({
  type: ADD_LEGALRUMIJA_SUCCESS,
  payload: data,
});

export const addLegalRumijaFail = error => ({
  type: ADD_LEGALRUMIJA_FAIL,
  payload: error,
});